<template>
    <main-content v-if="$can('manage-collective-gateways', 'ipg-gateway')" with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <kt-row v-if="status == 'success'" class="pb-4">
                    <kt-col md="3">
                        <router-link
                                v-if="form_data.gateway.type == 0"
                                :to="{ name: 'gateways_details', params: { hashid: form_data.gateway.id, gateway_source : 'starshop-gateways'}}"
                                class="btn btn-success"
                        >
                            {{ $t('label.gateway_details') }}
                        </router-link>
                        <router-link
                                v-else
                                :to="{ name: 'dedicated_details', params: { hashid: form_data.gateway.id }}"
                                class="btn btn-success"
                        >
                            {{ $t('label.gateway_details') }}
                        </router-link>
                    </kt-col>
                    <kt-col md="3">
                        <router-link
                            :to="{ name: 'user_details', params: { hashid: form_data.user.id }}"
                                class="btn btn-success"
                        >
                            {{ $t('label.user_details') }}
                        </router-link>
                    </kt-col>
                </kt-row>
                <setting-form shop_type="-1"></setting-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import settingForm from './components/switching-settings'
import {mapGetters} from "vuex";

export default {
    components: {
        'main-content': mainContent,
        'setting-form': settingForm,
    },
    computed: {
        ...mapGetters('collective', [
            'form_data',
            'status'
        ])
    },
    mounted() {
        this.$store.dispatch('collective/fetch');
    }
}
</script>

<style>

</style>